import React from 'react';

import { QuizBoxContainer } from './QuizBox.container';
import { QuizBoxView } from './QuizBox.view';
import QuizBoxWithPassageView from './QuizBoxWithPassage.view';

const QuizBox = () => {
  return (
    <QuizBoxContainer>
      {({
        onNext,
        onBack,
        question,
        choices,
        questionId,
        isLastQuestion,
        isFirstQuestion,
        isSubmitting,
        status,
        timeRemaining,
        variant,
        currentQuestionText,
        questionNo,
        questionType,
        precisionNumber,
        passage,
      }) => {
        if (passage) {
          return (
            <QuizBoxWithPassageView
              variant={variant}
              status={status}
              timeRemaining={timeRemaining}
              isSubmitting={isSubmitting}
              question={question}
              choices={choices}
              questionId={questionId}
              onNext={onNext}
              onBack={onBack}
              isLastQuestion={isLastQuestion}
              isFirstQuestion={isFirstQuestion}
              currentQuestionText={currentQuestionText}
              questionNo={questionNo}
              precisionNumber={precisionNumber}
              questionType={questionType}
              passage={passage}
            />
          );
        } else {
          return (
            <QuizBoxView
              variant={variant}
              status={status}
              timeRemaining={timeRemaining}
              isSubmitting={isSubmitting}
              question={question}
              choices={choices}
              questionId={questionId}
              onNext={onNext}
              onBack={onBack}
              isLastQuestion={isLastQuestion}
              isFirstQuestion={isFirstQuestion}
              currentQuestionText={currentQuestionText}
              questionNo={questionNo}
              precisionNumber={precisionNumber}
              questionType={questionType}
            />
          );
        }
      }}
    </QuizBoxContainer>
  );
};

export default QuizBox;
